
    import Component from "vue-class-component";
    import {
        QualificationRecordResultModel
    } from "@/api-client";
    import QualificationResultModalBase
        from "@/features/documents/qualifications/records/components/QualificationResultModalBase";

    @Component
    export default class QualificationResultEditModal extends QualificationResultModalBase {
        public open(result: QualificationRecordResultModel){
            this.result = QualificationRecordResultModel.fromJS(result);
            this.$refs.modal.show();
        }
    }
